import type {CourseExpandedCommon} from '../../../api/course';

import {not} from '../../conditionalUtils';
import {isDefined} from '../../typecheck';

export const groupCoursesByProgram = <
  C extends CourseExpandedCommon = CourseExpandedCommon,
>(
  courses: C[],
) => {
  const result: {
    courses: C[];
    program: C['program'];
  }[] = [];

  const groups: {[key: string]: C[]} = {};

  const groupByProgram = (course: C) => {
    const groupId = course.program_id;

    let targetGroup = groups[groupId];

    if (not(isDefined(targetGroup))) {
      targetGroup = groups[groupId] = [];
    }

    targetGroup!.push(course);
  };

  courses.forEach(groupByProgram);

  Object.keys(groups).forEach(key => {
    const group = groups[key]!;
    const program = group[0]!.program;

    result.push({courses: group, program});
  });

  return result;
};
